import { Grid, CardHeader, CardContent, Box, Select, MenuItem, TextField, Avatar} from "@mui/material";
import { apiAdsBidFree } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import React, { useEffect, useState } from "react";
import { IMAGE_BASE } from "../../utils/constants";
import CardLayout from "../../layouts/CardLayout";
import { useParams } from "react-router-dom";

const ViewBudFreeManagement = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiAdsBidFree.getById({ id: id });
        setData(response.data.data);
      } catch (error) {
        errorHandler(error);
      }
    };
    fetchData();
  }, [id]);

  return (
    <Box>
      <CardLayout>
        <CardHeader title={`View Watch Ads and Get Free Bid Management`} />
        <CardContent>
          <Grid container spacing={3}>

            <Grid item xs={12} md={12}>
              <Box
                mt={2}
                className="upload-box"                  >
                <Avatar
                  src={IMAGE_BASE + data?.thumbnailImage}
                  alt="preview"
                  className="avatar"
                />
              </Box>
            </Grid>

            <Grid item xs={6} md={6}>
              <h4 className="h4Design" >Types of Ads</h4>
              <TextField
                fullWidth
                required
                type="text"
                value={data?.type}
                name="type"
                disabled
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <h4 className="h4Design" >Free Bids</h4>
              <TextField
                fullWidth
                required
                type="text"
                value={data?.freeBid}
                name="freeBid"
                disabled
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <h4 className="h4Design" >Video Length</h4>
              <TextField
                fullWidth
                required
                type="text"
                value={data?.videoLength}
                name="videoLength"
                disabled
              />
            </Grid>

            <Grid item xs={6} md={6}>
              <h4 className="h4Design" >Short Description</h4>
              <TextField
                fullWidth
                required
                name="description"
                value={data?.description}
                disabled
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <h4 className="h4Design" >Video</h4>
              <Box>
                <video
                  src={IMAGE_BASE + data?.video}
                  controls
                  style={{ width: "100%" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <h4 className="h4Design" >Status</h4>
              <TextField
                fullWidth
                required
                type="text"
                value={data?.status}
                name="freeBid"
                disabled
              />
            </Grid>

          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewBudFreeManagement;